<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="list"
      class="elevation-1 bookTable"
      hide-default-footer
      disable-pagination
      @click:row="openBook($event)"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{ $t("mybook.myBookTitle") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <template>
            <v-btn
              class="mr-4 ml-4"
              color="primary"
              dark
              @click="uploadBookData.uploadDialog = true"
              >{{ $t("mybook.newBook") }}</v-btn
            >
          </template>
        </v-toolbar>
        <v-row class="ml-2 mr-2 mb-2" :class="lang == 'en' ? 'filterEN' : ''">
          <v-col cols="12" sm="6" md="2" class="mb-2 pt-0 pb-0">
            <TextField
              v-model="filter_name"
              :label="$t('mybook.bookName')"
              outlined
              dense
              hide-details="true"
              @keyup="searchFilter"
            ></TextField>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="mb-2 pt-0 pb-0">
            <v-autocomplete
              class="filtterMyBook"
              :items="itemsLangs"
              :label="$t('mybook.lang')"
              dense
              outlined
              item-text="langname"
              item-value="langid"
              hide-details="true"
              multiple
              chips 
              small-chips
            >
              <template v-slot:item="{ item }">
                <v-switch
                  color="#8bc34a"
                  :label="item.langname"
                  @change="searchFilter"
                  v-model="filter_lang"
                  :value="item.langid"
                  hide-details="true"
                  class="filtterMyBookSwitch"
                  inset
                  
                ></v-switch>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="mb-2 pt-0 pb-0">
            <v-select
              class="filtterMyBook"
              :items="itemsStatus"
              :label="$t('mybook.status')"
              dense
              outlined
              item-text="Name"
              hide-details="true"
            >
              <template v-slot:item="{ item }">
                <v-switch
                  color="#8bc34a"
                  :label="item.Name"
                  @change="searchFilter"
                  v-model="filter_status"
                  :value="item.value"
                  hide-details="true"
                  class="filtterMyBookSwitch"
                  inset
                ></v-switch>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="mb-2 pt-0 pb-0">
            <v-select
              class="filtterMyBook"
              :items="itemsDownloadable"
              :label="$t('mybook.downloadable')"
              dense
              outlined
              item-text="Name"
              hide-details="true"
            >
              <template v-slot:item="{ item }">
                <v-switch
                  color="#8bc34a"
                  :label="item.Name"
                  @change="searchFilter"
                  v-model="filter_downloadable"
                  :value="item.value"
                  hide-details="true"
                  class="filtterMyBookSwitch"
                  inset
                ></v-switch>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="mb-2 pt-0 pb-0">
            <v-autocomplete
              v-model="categoriesObject"
              :items="categoriesObject"
              outlined
              dense
              :readonly="true"
              chips
              class="filtterMyBook"
              small-chips
              :label="$t('mybook.categories')"
              multiple
              item-text="categoryname"
              item-value="categoryid"
              @focus="dialogCategoryTree = true"
              hide-details="true"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.bookid`]="{ item }">
        {{
          list
            .map(function (x) {
              return x.bookid;
            })
            .indexOf(item.bookid) + 1
        }}
      </template>
      <template v-slot:[`item.counterview`]="{ item }">
        <span class="mr-2 chipsstyle" color="green" label outlined>
          {{ item.counterview + " " + $t("public.once") }}
        </span>
      </template>
      <template v-slot:[`item.counterdownload`]="{ item }">
        <span class="mr-2 chipsstyle" color="green" label outlined>
          {{ item.counterdownload + " " + $t("public.once") }}
        </span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <p v-if="item.status == false">
          <span :title="$t('public.notactive')"
            ><i class="status fa fa-times-circle red--text"></i
          ></span>
        </p>
        <p v-if="item.status == true">
          <span :title="$t('public.active')"
            ><i class="status fa fa-check-circle green--text"></i
          ></span>
        </p>
      </template>
      <template v-slot:[`item.ispublish`]="{ item }">
        <p v-if="item.ispublish == false">
          <span :title="$t('public.notpublish')"
            ><i class="status fa fa-clock orange--text"></i
          ></span>
        </p>
        <p v-if="item.ispublish == true">
          <span :title="$t('public.publish')"
            ><i class="status fas fa-check-double blue--text"></i
          ></span>
        </p>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          :title="$t('public.edit')"
          small
          class="mr-2"
          color="#1976D2"
          @click.stop="updateBook(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          :title="$t('public.delete')"
          small
          @click.stop="deleteItemMethod(item)"
          color="#FF5252"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <template>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="PagesNumber"
          :total-visible="7"
          @input="changePage($event)"
        ></v-pagination>
      </div>
    </template>
    <UploadFile v-model="uploadBookData" />

    <SelectTreeCategory
      :dialogCategoryTree="dialogCategoryTree"
      v-on:closeCatDialog="closeCategory($event)"
      v-on:closeCatDialogWithCategories="
        closeCatDialogWithCategoriesMethod($event)
      "
    />
    <DeleteBook @DialogClose="deletedBook" v-model="DeleteBookData"/>
  </v-container>
</template>

<style>
.chipsstyle {
  min-width: 80px;
  display: inline-block;
  text-align: center;
}
.bookTable tr:hover * {
  background-color: rgb(193, 207, 255) !important;
  cursor: pointer;
}

.filtterMyBook .v-input__append-inner {
  background: #ff9800;
  position: absolute;
  top: -7px;
  left: -11px;
  height: calc(100% - 2px);
  width: 40px;
  padding-top: 7px;
  border-radius: 4px;
}
.filtterMyBook .v-input__append-inner i {
  color: #fff !important;
}
.filtterMyBook .v-input__control > .v-input__slot fieldset {
  border-radius: 4px !important;
  border: 1px solid #9e9e9e !important;
}
.filtterMyBookSwitch.v-input--selection-controls.v-input {
  margin-top: 0 !important;
}
.filterEN .v-select__slot label {
  left : 30px !important
}
.filterEN .v-select__slot  {
  padding-left: 30px;
}
.filterEN  legend {
  margin-left: 30px;
}
/* .filterEN .v-text-field--outlined legend{
  left: 44px;
    position: relative;
    background: rgb(255, 255, 255);
} */
/* .filtterMyBookSwitch .v-input--selection-controls__ripple{
  display: none;
} */
</style>
<script>
// import Breadcrumbs from "@/components/Global/Breadcrumbs";
// import AddVersion from "@/components/Versions/AddVersion";
import DeleteBook from "@/components/Books/DeleteBook";
import SelectTreeCategory from "@/components/Category/SelectTreeCategory";
import UploadFile from "@/components/Books/UploadBookDialog";

import TextField from "@/components/Elements/TextField";
// import AutoComplate from "@/components/Elements/AutoComplate";

export default {
  computed: {
    lang() {
        return this.$store.getters.getLang;
      },
    headers() {
      return [
        { text: "#", value: "bookid", width: "6%" },
        { text: this.$t("mybook.bookName"), value: "bookname", width: "30%" },
        {
          text: this.$t("mybook.counterView"),
          value: "counterview",
          width: "15%",
        },
        {
          text: this.$t("mybook.counterDownload"),
          value: "counterdownload",
          width: "15%",
        },
        { text: this.$t("mybook.status"), value: "status", width: "10%" },
        {
          text: this.$t("mybook.isPublished"),
          value: "ispublish",
          width: "10%",
        },
        { text: this.$t("mybook.action"), value: "action", width: "14%" },
      ];
    },

    itemsStatus() {
      return [
        { Name: this.$t("filtter.Published"), value: 1 },
        { Name: this.$t("filtter.NotPublished"), value: 0 },
      ];
    },

    itemsDownloadable() {
      return [
        { Name: this.$t("filtter.Downloadable"), value: 1 },
        { Name: this.$t("filtter.NotDownloadable"), value: 0 },
      ];
    },

  },

  data: () => ({
    rules: {
      requiredArray: (value) => !!value || this.$t("valid.required"),
    },

    uploadBookData: {
      uploadDialog: false,
      BookInformation: {},
    },
    DeleteBookData :{
      dialog : false ,
      deleteItem : null
    },

    dialogCategoryTree: false,
    categoriesObject: [],
    selectedCatIDS: "",
    list: [],
    itemsLangs: [],
    page: 1,
    PagesNumber: 0,
    pageUrl: 1,
    filter_name: "",
    filter_status: [],
    filter_downloadable: [],
    filter_lang: [],
    editItem: {},
    deleteItem: {},

    // ------- add version -------
    ItemDetails: {},
    addDialogVersion: false,
    // ------- Delete Book -------
    deleteBook: false,
    versionsLoading: false,
    selectedVersion: "",

    uploadBookDialog: false,
  }),
  mounted() {
    this.getAllBooks();
    this.getAllLang();
    this.filterStatmint =
      "&filter[bookname]=" +
      this.filter_name +
      "&filter[ispublish]=" +
      this.filter_status +
      // "&filter[isdownloadable]=" +
      // this.filter_downloadable +
      "&filter[langid]=" +
      this.selectedCatIDS;
  },
  components: {
    // Breadcrumbs,
    // AddVersion,
    DeleteBook,
    UploadFile,
    SelectTreeCategory,
    TextField,
    // AutoComplate,
  },
  methods: {
    openBook(item) {
      this.$router.push({
        name: "ReadBook",
        params: {
          bookID: item.bookid,
        },
      });
    },
    getAllBooks() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/mybook?per_page=20&page=" + this.pageUrl + this.filterStatmint
        )
        .then((response) => {
          this.PagesNumber = response["data"]["meta"]["last_page"];
          this.list = response["data"]["data"];
        });
    },

    
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/lang").then((response) => {
        for (let index = 0; index < response["data"]["data"].length; index++) {
          this.itemsLangs.push({
            langname: response["data"]["data"][index]["langname"],
            langid: response["data"]["data"][index]["langid"],
          });
        }
      });
    },
    changePage(val) {
      this.pageUrl = val;
      this.getAllBooks();
    },
    searchFilter() {
      this.pageUrl = 1;
      this.filterStatmint =
        "&filter[bookname]=" +
        this.filter_name +
        "&filter[ispublish]=" +
        this.filter_status +
        // "&filter[isdownloadable]=" +
        // this.filter_downloadable +
        "&filter[langid]=" +
        this.filter_lang +
        "&filter[categories.categoryid]=" +
        this.selectedCatIDS;
      this.getAllBooks();
    },
    goAddBook() {
      this.$router.push({ name: "UploadBook" }).catch(() => {});
    },
    deletedBook (event ){
        if(event){
          this.DeleteBookData.dialog = false ;
          this.getAllBooks()
        }
    },
    editItemMethod(item) {
      this.editItem = { ...item };
      this.editDialog = true;
    },
    deleteItemMethod(item) {
      this.DeleteBookData.deleteItem = { ...item };
      // this.deleteBook = true;
      this.DeleteBookData.dialog = true
    },
    addVersion(item) {
      this.ItemDetails = item;
      this.addDialogVersion = true;
    },
    DialogClose(val) {
      if (val == true) {
        this.getAllBooks();
      }
      this.addDialogVersion = false;
      this.deleteBook = false;
    },
    bookDitails(item) {
      this.$router.push({
        name: "DetailsBook",
        params: { bookID: item.bookid },
      });
    },
    closeCategory() {
      this.dialogCategoryTree = false;
    },
    closeCatDialogWithCategoriesMethod(vals) {
      this.categoriesObject = vals;
      let categoryID = [];
      for (let index = 0; index < vals.length; index++) {
        categoryID.push(vals[index]["categoryid"]);
      }
      this.dialogCategoryTree = false;
      this.selectedCatIDS = "";
      for (let index = 0; index < categoryID.length; index++) {
        this.selectedCatIDS += categoryID[index] + ",";
      }
      this.searchFilter();
    },
    updateBook(item){ 
      // DetailsBook
       this.$router.push({
        name: "DetailsBook",
        params: { bookID: item.bookid },
      });

      // this.$router.push('BookUpdate/' + item.bookid)
    }
  },
};
</script>